import { getMessages } from '../../../../../../../store/constants';

export const TAG_REMOVE_ICON_TOOLTIP = getMessages().getText('card_form_tag_remove');
export const TAG_EDIT_ICON_TOOLTIP = getMessages().getText('common.edit');
